var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3889 11.5428C8.3886 12.1654 8.15476 12.7623 7.7388 13.2023C7.32284 13.6423 6.75884 13.8893 6.17088 13.889C5.58292 13.8887 5.01916 13.6411 4.60361 13.2007C4.18807 12.7602 3.95478 12.163 3.95508 11.5405C3.95537 10.9179 4.18922 10.321 4.60518 9.88102C5.02114 9.44103 5.58514 9.19402 6.1731 9.19434C6.76106 9.19465 7.32482 9.44225 7.74036 9.88268C8.15591 10.3231 8.38919 10.9203 8.3889 11.5428ZM8.45541 15.6272H4.02159V30.3215H8.45541V15.6272ZM15.4608 15.6272H11.0492V30.3215H15.4165V22.6105C15.4165 18.3149 20.7038 17.9158 20.7038 22.6105V30.3215H25.0822V21.0143C25.0822 13.7728 17.2565 14.0427 15.4165 17.599L15.4608 15.6272Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFooter);
export default __webpack_public_path__ + "static/media/linkedin-footer.2915688cdc24f66c8f2b293804b10859.svg";
export { ForwardRef as ReactComponent };